module.exports = __webpack_public_path__ + "img/reference-punkt3.d3cb4dc4.webp";